import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function VarificationScreen() {
    const navigate = useNavigate();
    const handleSubmit = () =>{
        // business-details
        navigate('/business-details')
    }
  return (
    <div class="mid-contant">
	<div class="container">		
		<div class="row">
			<div class="col-12">
				<div class="head">
					<h2>Verify Mobile number</h2>
				</div>
			</div>
			
			<div class="col-12">
				<div class="registerbox">
					<div class="row mb-3">
						<div class="col-12 col-lg-7">
							<form onSubmit={handleSubmit} >
							<div class="row">
							
								<div class="col-12">
									<div class="otptxt">Enter the 6 digit OTP sent to your mobile number: +91-9898989898</div>
								</div>
								
								<div class="col-12 col-md-8">
									<div class="form-floating">
										<input type="text" class="form-control" id="otp" placeholder="Enter OTP" value=""/>
										<label for="otp">Enter OTP</label>
									</div>
								</div>
								
								<div class="col-6 col-md-5">
									<button type="submit" class="btn btn-primary" id="">Verify Now</button>
								</div>
								
								<div class="col-6 col-md-7">
									<button type="button" class="btn btn-trp" id="">Resend OTP</button>
								</div>							
								
								<div class="col-12 mt-4 d-none">
									<div class="spinner-border spinner-border-sm text-primary" role="status">
										<span class="visually-hidden">Loading...</span>
									</div>									
									<div class="timmer">45</div>
								</div>
							</div>
							</form>							
						</div>
						
						<div class="col-12 col-lg-5 d-none d-lg-block border-start">
							<div class="rightbanner"><img src={require('../../assests/images/register.png')} alt="Oxigen" class="img-fluid"/></div>
						</div>				
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
  )
}
